var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66697 7.53876C8.87083 6.49783 10.4401 5.86816 12.1565 5.86816C15.9493 5.86816 19.024 8.94283 19.024 12.7356C19.024 14.2026 18.564 15.5621 17.7804 16.678L15.5903 12.7356H17.6505C17.6505 9.70139 15.1908 7.24166 12.1565 7.24166C10.6799 7.24166 9.33934 7.8242 8.35211 8.77202L7.66697 7.53876ZM16.6461 17.9325C15.4422 18.9734 13.8729 19.6031 12.1565 19.6031C8.36373 19.6031 5.28906 16.5284 5.28906 12.7356C5.28906 11.2686 5.74904 9.90909 6.53262 8.79332L8.7228 12.7356H6.66256C6.66256 15.7699 9.12229 18.2296 12.1565 18.2296C13.6332 18.2296 14.9737 17.647 15.961 16.6993L16.6461 17.9325Z",
    fill: "#7E8392"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetain);
export default __webpack_public_path__ + "static/media/retain.63b9c80270bc547d99fa67fa319d1ad0.svg";
export { ForwardRef as ReactComponent };